export const SET_USER = 'USER.SET_USER'
export const SET_BUSINESS_CATEGORIES = 'USER.SET_BUSINESS_CATEGORIES'
export const SET_IS_FNB_BUSINESS_CATEGORY = 'USER.SET_IS_FNB_BUSINESS_CATEGORY'
export const LOGOUT_USER = 'USER.LOGOUT_USER'
export const SET_ONBOARDING_STEPS = 'USER.SET_ONBOARDING_STEPS'
